// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HnJE","placeholdersHeader":"styles_placeholdersHeader__1p-Xe","editorStyle":"styles_editorStyle__2GeI-","placeholdersBox":"styles_placeholdersBox__3pMlx"};